export interface IHoldsConfigurationObject {
  detailRoute?: string;
  centerRoute?: string;
}

export class HoldsConfigService {
  private _detailRoute: string;
  private _centerRoute: string;

  constructor() {
    this._detailRoute = 'my.holdsdetail';
    this._centerRoute = 'my.holdscenter';
  }

  config(config: IHoldsConfigurationObject): void {
    if (config.detailRoute) {
      this._detailRoute = config.detailRoute;
    }
    if (config.centerRoute) {
      this._centerRoute = config.centerRoute;
    }
  }

  get detailRoute() {
    return this._detailRoute;
  }

  get centerRoute() {
    return this._centerRoute;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/servants/holds_config_servant.ts